import * as React from "react";

function SvgReleaseNotes(props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) {
  return <svg viewBox="0 0 24 24" ref={svgRef} {...props}><path d="M10.8 17.28l-5.64-5.64 1.68-1.68 3.96 3.96L20.88 3.84A12.624 12.624 0 0012 0a12 12 0 1012 12 11.7 11.7 0 00-1.68-6.12z" fill="currentColor" /></svg>;
}

const ForwardRef = React.forwardRef(SvgReleaseNotes);
export default ForwardRef;